import {
  DialogContent,
  DialogActions,
  Button,
  useSwipeableViews,
  Stack,
  tokens,
} from '@cast/design-system';

import { AssignCredentialsDialogHeader } from 'hooks/dialogs/cluster/_components/AssignCredentialsDialogHeader';
import { ErrorState } from 'hooks/dialogs/cluster/_components/ErrorState';

type Props = {
  onClose: () => void;
};

export const ErrorSlide = ({ onClose }: Props) => {
  const swipeableCtx = useSwipeableViews();

  return (
    <Stack position="relative" data-testid="error-slide">
      <AssignCredentialsDialogHeader dismiss={onClose} />
      <DialogContent>
        <ErrorState title="Failed to extend cluster" />
      </DialogContent>
      <DialogActions
        sx={{ py: 16, borderTop: tokens.theme.border.structural.neutralSubtle }}
      >
        <Button onClick={onClose} variant="secondary">
          Close
        </Button>
        <Button
          testId="retry-button"
          onClick={() => swipeableCtx?.setSlide('runTheScript')}
        >
          Retry
        </Button>
      </DialogActions>
    </Stack>
  );
};
